import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,{attrs:{"fluid":""}},[(_vm.loading)?_c('loading'):_c('customer-order'),_c('info-alert',{attrs:{"text":_vm.infoAlertText,"alert-type":_vm.alertOrderType,"alert-font-size":_vm.alertOrderFontSize},model:{value:(_vm.infoAlertState),callback:function ($$v) {_vm.infoAlertState=$$v},expression:"infoAlertState"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }